import React, { useState } from "react";
import { Link } from "react-router-dom";
import { HiExternalLink } from "react-icons/hi";
import PageTableHeader from "../../../../components/pageTableHeader/pageTableHeader";

const cardData = [
  {
    title: "Academic Reports",
    detail: "View student performance across subjects and terms.",
    link: "/reports/academic",
    access: null,
  },
  {
    title: "Staff Attendance Reports",
    detail: "Track attendance for staff.",
    link: "/reports/attendance/staff",
    access: null,
  },
  {
    title: "Students Attendance Reports",
    detail: "Track attendance for students.",
    link: "/reports/attendance/student",
    access: null,
  },
  {
    title: "Teacher Performance Reports",
    detail: "Analyze teacher performance metrics.",
    link: "/reports/teacher-performance",
    access: null,
  },
  {
    title: "Fee Reports",
    detail: "Review fee collection and outstanding dues.",
    link: "/reports/Fee",
    access: null,
  },
  {
    title: "Examination Reports",
    detail: "Analyze examination results and performance.",
    link: "/reports/examination",
    access: null,
  },
];

const ReportSetup = () => {
  const items = [{ label: "Home", path: "/" }, { label: "Reports" }];

  return (
    <div className={"flex flex-col gap-2"}>
      <div className="flex flex-row justify-between items-center bg-white h-14">
        <PageTableHeader
          breadcrumbs={items}
          isSearch={false}
          isFilter={false}
          buttons={false}
        />
      </div>
      <div
        className={
          "bg-white grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 p-4"
        }
      >
        {cardData.map((card, index) => (
          <Card
            key={index}
            title={card.title}
            detail={card.detail}
            link={card.link}
          />
        ))}
      </div>
    </div>
  );
};

const Card = ({ title, detail, link }) => {
  const [active, setActive] = useState(false);

  const handleClick = () => {
    setActive(!active);
  };

  return (
    <div
      className={`flex flex-col justify-between bg-gray-50 p-3 hover:bg-white/10 rounded-md border`}
    >
      <div className={"flex justify-between items-start"}>
        <Link to={link} className={"flex flex-col gap-1"}>
          <span className={"text-sm font-bold text-theme"}>{title}</span>
          <span className={"text-xs text-textLight"}>{detail}</span>
        </Link>
      </div>
      {link && (
        <Link
          to={link}
          className={
            "text-xs text-theme mt-2 flex items-center gap-[2px] font-medium w-full"
          }
        >
          Show All
          <span className={"rounded-full flex justify-center items-center"}>
            <HiExternalLink className={"text-md text-theme"} />
          </span>
        </Link>
      )}
    </div>
  );
};

export default ReportSetup;
